import { BasePrescriptionTemplate } from './BasePrescriptionTemplate';
import type { PrescriptionPrintTemplateProps } from '../types';

const extractOphthalmologySummary = (specialtyData: Record<string, unknown> | null): string | null => {
  if (!specialtyData) return null;

  const ophthalmology = specialtyData.oftalmologia;
  if (!ophthalmology || typeof ophthalmology !== 'object') return null;

  const visualAcuity = (ophthalmology as { visual_acuity?: unknown }).visual_acuity;
  if (typeof visualAcuity !== 'string' || visualAcuity.trim() === '') return null;

  return `Oftalmología: agudeza visual registrada ${visualAcuity.trim()}.`;
};

export function OphthalmologyPrescriptionTemplate(props: PrescriptionPrintTemplateProps) {
  const ophthalmologySummary = extractOphthalmologySummary(props.specialtyData);

  if (!ophthalmologySummary) {
    return <BasePrescriptionTemplate {...props} />;
  }

  const mergedRecommendations = props.consultation.general_recommendations
    ? `${ophthalmologySummary}\n${props.consultation.general_recommendations}`
    : ophthalmologySummary;

  return (
    <BasePrescriptionTemplate
      {...props}
      consultation={{
        ...props.consultation,
        general_recommendations: mergedRecommendations,
      }}
    />
  );
}
